import { useEffect, useState } from 'react';

/**
 * Região `aria-live` (§13).
 *
 * Atualizações relevantes usam `polite`; erros de carregamento usam
 * `role="alert"`. O texto é limpo e reescrito para que o leitor de tela
 * anuncie de novo mesmo quando a mensagem se repete.
 */
export function RegiaoViva({
  mensagem,
  urgente = false,
}: {
  mensagem: string | undefined;
  urgente?: boolean;
}) {
  const [texto, setTexto] = useState('');

  useEffect(() => {
    if (mensagem === undefined || mensagem === '') {
      setTexto('');
      return;
    }
    setTexto('');
    const id = window.setTimeout(() => setTexto(mensagem), 40);
    return () => window.clearTimeout(id);
  }, [mensagem]);

  if (urgente) {
    return (
      <div className="apenas-leitor" role="alert">
        {texto}
      </div>
    );
  }

  return (
    <div className="apenas-leitor" role="status" aria-live="polite" aria-atomic="true">
      {texto}
    </div>
  );
}
